import { Outlet } from 'react-router-dom'
import { Logo } from '@/components/brand'
import { useT } from '@/internationalization/i18n'

/**
 * Unauthenticated, link-shared pages — a shared meeting summary.
 *
 * No navigation, no tenant switcher, no notification bell: a recipient of a
 * share link is not a user of the workspace, and offering them app chrome they
 * cannot use invites them to try.
 */
export function PublicLayout() {
  const t = useT()
  return (
    <div className="min-h-dvh bg-canvas">
      <header className="flex h-topbar items-center justify-between border-b border-border px-4 sm:px-6">
        <Logo size="md" />
        <a href="/login" className="text-base font-medium text-brand hover:underline">
          {t('common.signIn')}
        </a>
      </header>
      <main className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6">
        <Outlet />
      </main>
    </div>
  )
}
